export default {
  getJobListingNotification: (state) => state.jobListingNotification,
};
